
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Nagpur District Under-07 and Under-17 Chess Championship 2025</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">

        <div class="row justify-content-between">
            <div class="col-md-12">

                <p>Nagpur, March 23, 2025 – The Nagpur District Chess Championship 2025 concluded on a high note, witnessing impressive performances from young chess enthusiasts. Organized by Chess Association Nagpur in collaboration with G.H. Raisoni Sports and Cultural Foundation, MKH Sancheti Group, and Kalpana Prakash Welfare Foundation, the championship was held at Vivekanand Hall, Shraddha House, Kingsway, near Kasturchand Park.
                </p>
                <h5 class="fw-bold">Winners and Performances : </h5>
                <h6>Under-7 Open Category :</h6>
                <ul class="list-style list-style1">
                  <li><strong>Champion:</strong> Riaan Ritesh Jham, with a perfect score of 6 points from 6 rounds.</li>

                  <li><strong>2nd Place:</strong> Nihansh Khode (5 points)</li>

                  <li><strong>3rd Place:</strong> Dhruv Daswani (5 points)</li>
                </ul>
                <h6> Under-7 Girls Category :</h6>
                  <ul class="list-style list-style1">
                    <li><strong>Champion:</strong> Avika Rathi, determined by a tie-break with 5 points.</li>

                  <li><strong>Runner-up:</strong> Aasawari Arvind Akinwar (5 points)</li>
                  </ul>
                  <h6>Under-17 Open Category :</h6>


                <ul class="list-style list-style1">
                    <li><strong>Champion:</strong> Sai Sharma, with 5.5 points.</li>

                  <li><strong>Runner-up:</strong> Yuval Sunil Mohurle (5 points)</li>
                </ul>
                  <h6>Under-17 Girls Category :</h6>


                <ul class="list-style list-style1">
                    <li><strong>Champion:</strong> Shraddha Bajaj, after a tie-break score with 5.5 points.</li>

                  <li><strong>Runner-up:</strong> Vritika (5.5 points)</li>
                </ul>
            </div>
            <!-- <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/sport/upcoming-sports/fide-rapid-rating-chess-tournament.webp"
                        alt="GHRSCF" />

                </div>
            </div> -->
        </div>
        <h5 class="fw-bold"> State-Level Representation </h5>

        <p>The top two finishers in each category have earned the honor of representing Nagpur at the upcoming Maharashtra State Under-7 and Under-17 Open & Girls Chess Championship 2025.</p>

      <h5 class="fw-bold">  Prize Distribution</h5>
       <p> For the first time, the championship introduced cash prizes sponsored by MKH Sancheti Group:</p>
       <ul class="list-style list-style1">
        <li> <strong>Winner:</strong> ₹2,000 and a trophy</li>

        <li> <strong>Runner-up:</strong> ₹1,000 and a trophy</li>

        <li> <strong>Top 5 Finishers:</strong> Cash prizes and trophies</li>
       </ul>
       <p> Under-11, Under-9, and Under-7 Age Groups: Medals for the top three players</p>

        <p>The awards were presented by Dr. Praveen Kaur, Administration Head, MKH Sancheti Group, in the presence of Shri Bhushan Shriwas, Secretary, Chess Association Nagpur, and IA Shiva Iyer.</p>

        <h5 class="fw-bold">Event Officials</h5>
        <p>The tournament was successfully conducted by FA Shiva Iyer as the Chief Arbiter, with support from FA Amit Tembhurne, SNA Prayas Ambade, SNA Akash Rewatkar, and Shyam Agrawal.</p>
        <p>Congratulations to all the winners and participants for making the championship a resounding success!</p>

            <div class="section section-md fide-chesscompetition section-banner-bg-1">
                <div class="container">

                    <div class="row row-cols-1 row-cols-md-1">


                        <!-- <div class="col">
                            <div class="gall-ery">
                                <div class="row">
                                    <div class="col-md-7">
                                        <div class="widget_title inner-title gall-sys shadow-text-sm">
                                            <h4 class="fw-bold">Photos</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="lightBox--gallery">
                                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament.webp"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament.webp">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament.webp"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament1.webp"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament1.webp">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament1.webp"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament2.webp"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament2.webp">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament2.webp"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament3.webp"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament3.webp">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament3.webp"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament4.webp"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament4.webp">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament4.webp"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament5.webp"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament5.webp">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/fide-rapit-rating-chess-tournament5.webp"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div> -->
                        <div class="col">
                            <div class="gall-ery">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4 class="fw-bold">Media Coverage</h4>
                                </div>
                                <div class="lightBox--gallery">
                                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">

                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/under7-and-under17-chess-champ-25-1.webp"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/under7-and-under17-chess-champ-25-1.webp">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/under7-and-under17-chess-champ-25-1.webp"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img
                                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/under7-and-under17-chess-champ-25.webp"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/under7-and-under17-chess-champ-25.webp">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/under7-and-under17-chess-champ-25.webp"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img
                                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/under7-and-under17-chess-champ-25-2.webp"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/under7-and-under17-chess-champ-25-2.webp">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/under7-and-under17-chess-champ-25-2.webp"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img
                                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

    </div>

</section>
